import { Hosts, FetchHostsParams } from './types';
import { FailureActionPayload } from 'store/errors/types';
import { createAsyncAction, createAction } from 'typesafe-actions';

export interface FetchHostsSuccessPayload {
  hosts: Hosts;
  params: FetchHostsParams;
}

export const fetchHosts = createAsyncAction('hosts/FETCH_REQUEST', 'hosts/FETCH_SUCCESS', 'hosts/FETCH_FAILURE')<
  FetchHostsParams,
  FetchHostsSuccessPayload,
  FailureActionPayload
>();

export const saveHostSearchValue = createAction('hosts/SAVE_SEARCH_VALUE')<string>();

export const resetHosts = createAction('hosts/RESET')();
